/*
 * The mockup's `.design`, flat: the profile list in the first column, the form in the second, the
 * live preview and contrast in the third. The editor's own wrapper is `display: contents`, so its
 * form and its live side are cells of this grid.
 */
.workspace {
  display: grid;
  grid-template-columns: 220px minmax(320px, 380px) minmax(0, 1fr);
  gap: var(--space-4);
  align-items: start;
}

.list {
  grid-column: 1;
  min-inline-size: 0;
}

/* As in the mockup: a narrower list below 1280px (the live side drops under both), one column below 1024px. */
@media (max-width: 1279.98px) {
  .workspace {
    grid-template-columns: 200px minmax(0, 1fr);
  }
}

@media (max-width: 1023.98px) {
  .workspace {
    grid-template-columns: minmax(0, 1fr);
  }
}
